"use client";

type EventParams = Record<string, any>;

/**
 * Global tracking utility to trigger events across different platforms (Meta Pixel, GA4, Google Ads)
 */
export const trackEvent = (eventName: string, params: EventParams = {}) => {
    if (typeof window === "undefined") return;

    // 1. Meta Pixel
    if (typeof window.fbq === "function") {
        // Standard events check (Meta has a list of standard events like Lead, ViewContent, etc.)
        const standardEvents = [
            "AddPaymentInfo", "AddToCart", "AddToWishlist", "CompleteRegistration",
            "Contact", "CustomizeProduct", "Donate", "FindLocation", "InitiateCheckout",
            "Lead", "Purchase", "Schedule", "Search", "StartTrial", "SubmitApplication",
            "Subscribe", "ViewContent"
        ];

        if (standardEvents.includes(eventName)) {
            window.fbq("track", eventName, params);
        } else {
            window.fbq("trackCustom", eventName, params);
        }
    }

    // 2. Google Analytics (GA4)
    if (typeof window.gtag === "function") {
        window.gtag("event", eventName, params);
    }

    // 3. TikTok Pixel
    if (typeof window.ttq === 'object' && typeof window.ttq.track === 'function') {
        window.ttq.track(eventName, params);
    }

    // 4. X (Twitter) Pixel
    if (typeof window.twq === 'function') {
        window.twq('event', eventName, params);
    }

    // Debug log in development
    if (process.env.NODE_ENV === "development") {
        console.log(`[Tracking] Event: ${eventName}`, params);
    }
};

/**
 * Specific utility for Google Ads Conversion
 */
export const trackGoogleAdsConversion = (conversionId: string, label: string, params: EventParams = {}) => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
            send_to: `${conversionId}/${label}`,
            ...params,
        });
    }
};

// Global type definitions for window object
declare global {
    interface Window {
        fbq: any;
        gtag: any;
        ttq: any;
        twq: any;
        dataLayer: any[];
        trackLead?: (formName: string) => void;
        trackContact?: (type: 'whatsapp' | 'phone' | 'email', value: string) => void;
    }
}
